import * as dom from './dom';
import * as scroll from './scroll';
import * as helper from './helper';
import * as fns from './function';
export default { dom, helper, scroll, fns };
